import { render, staticRenderFns } from "./short-list.vue?vue&type=template&id=708d42cc"
import script from "./short-list.vue?vue&type=script&lang=js"
export * from "./short-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports